import http from '../common/http-common';


import { DTOEquipoInventario } from '../../DTO/Inventario/DTOEquipoInventario';

import { DTOMonitorInventario } from '../../DTO/Inventario/DTOMonitorInventario';
 import { DTOIPInventario } from '../../DTO/Inventario/DTOIPInventario';


import {
  DTOEstadoEquipo,
  DTOSegmentoRed,
  DTOTipoEquipo,
} 
from '../../DTO/Inventario/DTOCatalogosInventario'


import {
  DTOGestionarEquipo,
  DTOGestionarIP,
  DTOGestionarMonitor,
  DTOGestionarSegmentoRed,
  DTOResultadoGestion,
} 
from '../../DTO/Inventario/DTOGestionInventario'



class InventarioService {
  obtenerEquipos() {
    return http.get<DTOEquipoInventario[]>(
      '/inventario/equipos'
    );
  }

  obtenerEquipoPorId(idEquipo: number) {
    return http.get<DTOEquipoInventario>(
      `/inventario/equipos/${idEquipo}`
    );
  }

  obtenerMonitoresPorEquipo(idEquipo: number) {
    return http.get<DTOMonitorInventario[]>(
      `/inventario/equipos/${idEquipo}/monitores`
    );
  }

  obtenerIPsPorEquipo(idEquipo: number) {
    return http.get<DTOIPInventario[]>(
      `/inventario/equipos/${idEquipo}/ips`
    );
  }

  obtenerTiposEquipo() {
    return http.get<DTOTipoEquipo[]>(
      '/inventario/catalogos/tipos-equipo'
    );
  }

  obtenerEstadosEquipo() {
    return http.get<DTOEstadoEquipo[]>(
      '/inventario/catalogos/estados-equipo'
    );
  }

  obtenerSegmentosRed() {
    return http.get<DTOSegmentoRed[]>(
      '/inventario/catalogos/segmentos-red'
    );
  }

  gestionarEquipo(dto: DTOGestionarEquipo) {
    return http.post<DTOResultadoGestion>(
      '/inventario/equipos/gestionar',
      dto,
      {
        headers: {
          'Content-Type': 'application/json',
        },
      }
    );
  }

  gestionarMonitor(dto: DTOGestionarMonitor) {
    return http.post<DTOResultadoGestion>(
      '/inventario/monitores/gestionar',
      dto,
      {
        headers: {
          'Content-Type': 'application/json',
        },
      }
    );
  }

  gestionarIP(dto: DTOGestionarIP) {
    return http.post<DTOResultadoGestion>(
      '/inventario/ips/gestionar',
      dto,
      {
        headers: {
          'Content-Type': 'application/json',
        },
      }
    );
  }

  gestionarSegmentoRed(dto: DTOGestionarSegmentoRed) {
    return http.post<DTOResultadoGestion>(
      '/inventario/segmentos-red/gestionar',
      dto,
      {
        headers: {
          'Content-Type': 'application/json',
        },
      }
    );
  }
}

export default new InventarioService();